import { ChangeDetectionStrategy, Component, computed, effect, inject, input, OnDestroy, signal } from '@angular/core';

import { ButtonComponent } from '@program-suite/ui';
import { AgencySaveREQ, AgencyStore, LookupStore } from '@program-suite/data-common';
import { AdminSettingsStore } from '../../data/admin-settings.store';
import { AgencyFormModel, UiAgencyFormComponent } from '@program-suite/ui-agency-form';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'lib-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss', '../admin-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, UiAgencyFormComponent, ReactiveFormsModule],
})
export class CompanyComponent implements OnDestroy {
  lookupStore = inject(LookupStore);
  agencyStore = inject(AgencyStore);
  adminSettingsStore = inject(AdminSettingsStore);
  programs = computed(() => this.lookupStore.programs?.() ?? []);
  states = computed(() => this.lookupStore.states?.() ?? []);
  companyForm!: FormGroup;

  constructor(private fb: FormBuilder, private route: ActivatedRoute,) {
    this.companyForm = this.fb.group({
      agency: [''],
    });

    const tenantId = this.route.snapshot.queryParams['tenantId'];
    if (tenantId) {
      this.adminSettingsStore.getTenantDetails(tenantId);
    } else {
      this.adminSettingsStore.getTenantDetails();
    }
    this.lookupStore.loadLookup('programs');
    this.lookupStore.loadLookup('states');

    effect(() => {
      const details = this.adminSettingsStore.tenantDetails?.();

      if (details) {
        const agency = {
          id: details.id,
          agencyName: details.name,
          streetAddress: details.address1,
          suite: details.address2,
          licenseNumber: details.license,
          city: details.city,
          stateId: details.stateId,
          zipCode: details.zipCode,
          phone: details.phone,
          websiteUrl: details.website,
          programIds: details.programIds,
          status: null,
        };
        this.companyForm.patchValue({ agency: agency });
      }
    });
  }

  ngOnDestroy() {
    this.agencyStore.setAgency(null);
  }

  onSubmit() {
    const agencyControl = this.companyForm.get('agency');
    const formValue = agencyControl ? agencyControl.value : null;

    if (!formValue) {
      console.error('Form value is null or undefined');
      return;
    } else {
      const details = {
        id: formValue.id,
        name: formValue.agencyName,
        address1: formValue.streetAddress,
        address2: formValue.suite,
        license: formValue.licenseNumber,
        city: formValue.city,
        stateId: formValue.stateId,
        zipCode: formValue.zipCode,
        phone: formValue.phone,
        website: formValue.websiteUrl,
        programIds: formValue.programIds,
        isActive: formValue.status === 'Active' ? true : false,
      };

      this.adminSettingsStore.updateTenantDetails(details);
    }
  }
}
